import { createFileRoute } from '@tanstack/react-router';
import { AdminDsrView, type DsrTabKey } from '@/components/admin/AdminDsrView';
import type { DsrPageParams } from '@/lib/queries/admin';

interface DsrSearch {
  readonly status?: DsrTabKey;
  readonly cursor?: string;
}

const ALLOWED_TABS: ReadonlyArray<DsrTabKey> = [
  'all',
  'received',
  'running',
  'completed',
  'overdue',
];

export const Route = createFileRoute('/_authed/admin/dsr/')({
  validateSearch: (raw: Record<string, unknown>): DsrSearch => {
    const status =
      typeof raw.status === 'string' &&
      (ALLOWED_TABS as ReadonlyArray<string>).includes(raw.status)
        ? (raw.status as DsrTabKey)
        : undefined;
    const cursor =
      typeof raw.cursor === 'string' && raw.cursor.length > 0
        ? raw.cursor
        : undefined;
    // Rejected keys are returned as explicit `undefined`: the router merges
    // this result over the raw URL search, so an omitted key would let the
    // raw value through to `useSearch()`.
    return { status, cursor };
  },
  component: AdminDsrPage,
});

function AdminDsrPage() {
  const search = Route.useSearch();
  const active: DsrTabKey = search.status ?? 'all';
  // 'all' clears the server-side filter; every other tab is a valid DsrStatus.
  const statusFilter = active === 'all' ? undefined : active;
  const listInput: DsrPageParams = {
    pageSize: 50,
    ...(statusFilter ? { status: statusFilter } : {}),
    ...(search.cursor ? { cursor: search.cursor } : {}),
  };
  return (
    <AdminDsrView listInput={listInput} active={active} cursor={search.cursor} />
  );
}
